// extracted by mini-css-extract-plugin
module.exports = {"seaGreen":"#08B73C","error":"#ff5a5a","brandOne":"#eba900"};